import {widgetDataHooks as DH} from '@wix/wix-events-data-hooks'
import classNames from 'classnames'
import React, {useEffect} from 'react'
import {getElementWidth} from '../../../../../../commons/utils/dom'
import {useWidgetHost, useWidgetState} from '../../../hooks/state-provider'
import {useEventsList} from '../../../hooks/use-events-list'
import {getCompId} from '../../../selectors/component'
import {focusFirstNewEvent} from '../../../utils/a11y'
import {CategoryTabs} from '../../category-tabs'
import {EmptyCategory} from '../../category-tabs/empty-category'
import {LoadMoreButton} from '../../load-more-button'
import {MainListTitle} from '../../main-list-title'
import {SideBySideItem} from '../side-by-side-item'
import s from './side-by-side-list.scss'
import {Utils} from './utils'

export const SideBySideList = () => {
  const {events, hasMore, moreLoading, pageLimit} = useEventsList()

  const utils = new Utils()
  const compId = useWidgetState(getCompId)
  const eventsCount = events.length
  const loadMoreVisible = hasMore || moreLoading

  const host = useWidgetHost()
  const width = useWidgetState(state => host.dimensions.width || getElementWidth(`#${state.component.id}`))

  useEffect(() => {
    focusFirstNewEvent({eventsCount, pageLimit, hasMore, compId})
  }, [eventsCount])

  return (
    <div className={classNames(s.container, s.padding)}>
      <MainListTitle />
      <CategoryTabs />
      {!events.length ? (
        <EmptyCategory />
      ) : (
        <div className={s.items}>
          <ul data-hook={DH.sideBySideItems} className={s.list}>
            {events.map((event: ExtendedEvent, index: number) => (
              <li
                key={event.id}
                className={classNames(s.item, utils.itemsHeightClass(width), s.widgetHeightSettings)}
                data-hook={DH.sideBySideItem}
              >
                <SideBySideItem event={event} evenItem={!!(index % 2)} />
              </li>
            ))}
          </ul>
          {loadMoreVisible && <LoadMoreButton hasMore={hasMore} moreLoading={moreLoading} />}
        </div>
      )}
    </div>
  )
}
